import React, { useState } from "react";
import "./ExploreBrands.css";

const brands = [
  {
    name: "Porsche",
    img: "/images/porsche.jpg",
    logo: "/images/porsche-logo.jpg",
    desc: "Iconic German sports cars, luxury performance.",
    details: {
      heritage:
        "Founded in 1931 in Stuttgart, Porsche blends precision engineering, motorsport success, and timeless design to craft world-renowned performance vehicles.",
      performance:
        "Porsche delivers exceptional handling and acceleration with models like 911, Taycan, and Cayenne. Most models exceed 400–650 hp with lightning 0–100 km/h times under 3 seconds.",
      engines:
        "Range includes flat-six, V6, V8, and fully electric powertrains. Hybrid options and turbocharged engines ensure both power and efficiency.",
      customization:
        "The Porsche Exclusive Manufaktur program lets you personalize every detail — bespoke colors, leather, stitching, and performance add-ons.",
      iconic:
        "The 911 Carrera remains the benchmark for sports cars, while Taycan leads Porsche’s EV revolution.",
      models: ["911", "Cayenne", "Macan", "Panamera", "Taycan"]
    }
  },
  {
    name: "BMW",
    img: "/images/bmw.jpeg",
    logo: "/images/bmw-logo.jpg",
    desc: "Dynamic driving experience, elegant design.",
    details: {
      heritage:
        "Founded in 1916, BMW embodies 'The Ultimate Driving Machine' philosophy, balancing innovation with sportiness.",
      performance:
        "From the agile 3 Series to the powerful M5 and futuristic iX, BMW offers precision handling and driver-focused performance, often exceeding 600 hp in M variants.",
      engines:
        "Equipped with turbocharged 4- and 6-cylinder engines, V8s, and advanced EV motors. Plug-in hybrids combine efficiency and strength.",
      customization:
        "BMW Individual offers tailor-made paint finishes, luxury interiors, and performance packages for a unique identity.",
      iconic:
        "The M3 and M5 are global performance icons, while the i-Series pushes BMW into the electric future.",
      models: ["3 Series", "5 Series", "X5", "i4", "iX", "M3", "M5"]
    }
  },
  {
    name: "Mercedes",
    img: "/images/mercedes.webp",
    logo: "/images/mercedes-logo.png",
    desc: "Luxury, comfort, and engineering excellence.",
    details: {
      heritage:
        "Mercedes-Benz, established in 1926, stands for innovation and ultimate comfort — the pioneer of modern luxury automobiles.",
      performance:
        "AMG performance variants and electric EQ models bring both power and refinement. The S-Class defines opulence, while AMG GT brings track-level thrill.",
      engines:
        "Offers a wide lineup — 4-cylinder, inline-6, V8 biturbo, V12, and high-torque electric motors in EQ models.",
      customization:
        "Mercedes-AMG and Designo programs allow bespoke leather, colors, and handcrafted finishes for a personal touch.",
      iconic:
        "The S-Class, G-Class, and AMG GT symbolize prestige and performance excellence worldwide.",
      models: ["A-Class", "E-Class", "S-Class", "G-Class", "EQC", "AMG GT"]
    }
  },
  {
    name: "Audi",
    img: "/images/audi.jpg",
    logo: "/images/audi-logo.webp",
    desc: "Progressive design with sporty performance.",
    details: {
      heritage:
        "Audi combines innovation with minimalism, famous for its Quattro all-wheel drive and sleek German engineering.",
      performance:
        "The RS lineup and e-tron GT showcase power and precision. Top RS models reach 0–100 km/h in around 3 seconds.",
      engines:
        "Turbocharged 4-cylinder, V6, V8, and fully electric motors across sedans, SUVs, and sportbacks.",
      customization:
        "Audi Exclusive lets owners choose unique color combinations, leathers, and stitching for complete personalization.",
      iconic:
        "RS7, R8, and e-tron GT stand as technological marvels merging design and performance.",
      models: ["A4", "A6", "Q7", "RS7", "R8", "e-tron GT"]
    }
  },
  {
    name: "Ferrari",
    img: "/images/ferrari.webp",
    logo: "/images/ferrari-logo.webp",
    desc: "Italian supercars, pure racing passion.",
    details: {
      heritage:
        "Founded by Enzo Ferrari in 1939, the brand defines automotive art, speed, and Italian craftsmanship.",
      performance:
        "Ferrari’s V8 and V12 engines produce up to 830 hp, offering 0–100 km/h in as little as 2.9 seconds.",
      engines:
        "Naturally aspirated and turbocharged V8s and V12s with advanced hybrid systems in models like SF90 Stradale.",
      customization:
        "Ferrari’s Tailor Made program lets buyers select exclusive materials, racing stripes, and color palettes.",
      iconic:
        "The SF90 Stradale, 812 Superfast, and classic F40 embody Ferrari’s unmatched legacy of performance and emotion.",
      models: ["F8 Tributo", "SF90 Stradale", "812 Superfast", "Roma", "Portofino"]
    }
  },
  {
    name: "Aston Martin",
    img: "/images/aston-martin.jpg",
    logo: "/images/aston-martin-logo.png",
    desc: "British luxury and grand touring excellence.",
    details: {
      heritage:
        "Founded in 1913, Aston Martin blends elegance, power, and exclusivity — the car of choice for James Bond.",
      performance:
        "V8 and V12 grand tourers offering smooth yet ferocious acceleration, reaching speeds beyond 330 km/h.",
      engines:
        "Twin-turbo V8 and naturally aspirated V12 provide thrilling performance and grand touring comfort.",
      customization:
        "Q by Aston Martin offers full personalization — from interior stitching to unique exterior paints.",
      iconic:
        "DB11, Vantage, and DBS Superleggera represent timeless British engineering and sophistication.",
      models: ["DB11", "Vantage", "DBS Superleggera", "DBX", "Rapide E"]
    }
  },
  {
    name: "Lamborghini",
    img: "/images/lamborghini.webp",
    logo: "/images/lamborghini-logo.webp",
    desc: "Bold Italian supercars with extreme design.",
    details: {
      heritage:
        "Since 1963, Lamborghini has redefined exotic design and performance with its roaring V12 engines.",
      performance:
        "Aventador and Huracán deliver breathtaking acceleration — over 750 hp and 0–100 km/h in under 3 seconds.",
      engines:
        "V10, V12, and new hybrid V12 systems power its line-up, blending performance with modern efficiency.",
      customization:
        "Ad Personam program enables custom interiors, one-of-a-kind colors, and carbon fiber detailing.",
      iconic:
        "Aventador, Huracán, and Countach heritage define Lamborghini’s reputation for wild styling and power.",
      models: ["Aventador", "Huracán", "Revuelto", "Urus"]
    }
  },
  {
    name: "Mustang",
    img: "/images/mustang.jpg",
    logo: "/images/mustang-logo.jpg",
    desc: "American muscle meets modern innovation.",
    details: {
      heritage:
        "Since 1964, the Ford Mustang has embodied the spirit of freedom, power, and American road culture.",
      performance:
        "Classic V8-powered Mustangs produce up to 760 hp, while the Mach-E electric SUV brings performance into the EV era.",
      engines:
        "V6, V8, and electric powertrains. GT500 variants feature supercharged engines with immense torque.",
      customization:
        "Available with performance packs, trims, and modern tech upgrades to suit every style.",
      iconic:
        "The Shelby GT500, Mach 1, and Mach-E represent Mustang’s blend of heritage and innovation.",
      models: ["Mustang GT", "Mach 1", "Shelby GT500", "Mach-E"]
    }
  }
];

const ExploreBrands = () => {
  const [selectedBrand, setSelectedBrand] = useState(null);

  const openModal = (brand) => setSelectedBrand(brand);
  const closeModal = () => setSelectedBrand(null);

  return (
    <section className="explore-brands">
      <h2>Explore Brands</h2>
      <div className="brands-grid">
        {brands.map((brand, index) => (
          <div key={index} className="brand-card">
            <img src={brand.img} alt={brand.name} />
            <div className="brand-info">
              <h3>{brand.name}</h3>
              <p>{brand.desc}</p>
              <button className="more-info-btn" onClick={() => openModal(brand)}>
                More Info
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedBrand && (
        <div className="brand-modal">
          <div className="modal-content">
            <span className="close-btn" onClick={closeModal}>&times;</span>

            <div className="modal-left-logo">
              <img src={selectedBrand.logo} alt={`${selectedBrand.name} logo`} />
            </div>

            <div className="modal-right-info">
              <h2>{selectedBrand.name}</h2>
              <h3>Brand Overview</h3>
              <p>{selectedBrand.details.heritage}</p>

              <h3>Performance & Models</h3>
              <p>{selectedBrand.details.performance}</p>
              <ul>
                {selectedBrand.details.models.map((model, i) => (
                  <li key={i}>{model}</li>
                ))}
              </ul>

              <h3>Engines</h3>
              <p>{selectedBrand.details.engines}</p>

              <h3>Customization</h3>
              <p>{selectedBrand.details.customization}</p>

              <h3>Iconic Highlights</h3>
              <p>{selectedBrand.details.iconic}</p>
            </div>
          </div>
        </div>
      )}
      
    </section>
  );
};


export default ExploreBrands;
